import React from "react";

const MatchVenue = ({ venue }) => {
  return (
    <div className="matchVenue_block">
      <div className="leg_head">
        <h2>Match Venue</h2>
      </div>

      <div className="global_table matchVenue_tbl">
        <table>
          <tbody>
            <tr>
              <td>Venue Name:</td>
              <td>{venue?.name ?? "NY"}</td>
            </tr>
            <tr>
              <td>Capacity:</td>
              <td>{venue?.capacity ?? "NY"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MatchVenue;
